var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-card",class:{
    '-active': _vm.cardInfo.flip,
    '-valid': _vm.cardInfo.valid,
    '-error': _vm.cardInfo.error
  }},[_vm._m(0),_c('div',{staticClass:"m-card_side -back"},[_c('p',[_vm._v(_vm._s(_vm.cardInfo.name))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-card_side -front"},[_c('img',{attrs:{"src":require("@/assets/valorant.png"),"alt":""}})])}]

export { render, staticRenderFns }